document.addEventListener('DOMContentLoaded',function(){
  var popup=document.querySelector('[data-welcome-popup]');
  if(!popup)return;
  var key='tiveluneWelcomePopupDismissedV2';
  var rewardKey='tiveluneWelcomeRewardV2';
  var success=Boolean(popup.querySelector('[data-popup-success]'));
  var hasError=Boolean(popup.querySelector('.welcome-popup__error'));
  var until=Number(localStorage.getItem(key)||0);
  var reward;
  try{reward=JSON.parse(localStorage.getItem(rewardKey)||'null');}catch(e){reward=null;}
  if(!reward){
    var random=popup.dataset.randomReward==='true';
    var draw=Math.random()*100;
    var percent=random?(draw<95?5:(draw<99?10:15)):Number(popup.dataset.fixedDiscount||15);
    var fallbackCodes={5:'NUITDOUCE',10:'PETITEETOILE',15:'LUNEDOR'};
    var code=random?(popup.dataset['code'+percent]||fallbackCodes[percent]):(popup.dataset.fixedCode||'LUNEDOR');
    reward={percent:percent,code:code};
    localStorage.setItem(rewardKey,JSON.stringify(reward));
  }
  var discountText=popup.querySelector('[data-welcome-discount]');
  if(discountText)discountText.textContent=reward.percent+'%';
  var codeText=popup.querySelector('[data-welcome-code]');
  if(codeText)codeText.textContent=reward.code;
  var animated=false;
  function animateReward(){
    if(animated||!discountText)return;
    animated=true;
    var values=[5,10,15,10,5,15,5,10,15];
    var step=0;
    function roll(){
      discountText.classList.remove('is-rolling');
      void discountText.offsetWidth;
      discountText.textContent=values[step%values.length]+'%';
      discountText.classList.add('is-rolling');
      step+=1;
      if(step<values.length && popup.classList.contains('is-open')){setTimeout(roll,230);}else{discountText.classList.remove('is-rolling');discountText.textContent=reward.percent+'%';}
    }
    roll();
  }
  function open(){popup.classList.add('is-open');popup.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';setTimeout(animateReward,220);}
  function close(){popup.classList.remove('is-open');popup.setAttribute('aria-hidden','true');document.documentElement.style.overflow='';var days=Number(popup.dataset.dismissDays||7);localStorage.setItem(key,String(Date.now()+days*86400000));}
  popup.querySelectorAll('[data-popup-close]').forEach(function(button){button.addEventListener('click',close);});
  document.addEventListener('keydown',function(event){if(event.key==='Escape'&&popup.classList.contains('is-open'))close();});
  var copy=popup.querySelector('[data-copy-code]');
  if(copy){
    copy.dataset.code=reward.code;
    copy.addEventListener('click',function(){
      var small=copy.querySelector('small');
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(reward.code).then(function(){if(small)small.textContent='Code copied!';}).catch(function(){if(small)small.textContent='Code: '+reward.code;});
      }else if(small){small.textContent='Code: '+reward.code;}
    });
  }
  var discountLink=popup.querySelector('[data-discount-link]');
  if(discountLink){
    var localeRoot=window.Shopify?.routes?.root||'/'; var redirect=discountLink.dataset.discountRedirect||(localeRoot+'products/ergonomic-kids-pillow');
    discountLink.href=localeRoot+'discount/'+encodeURIComponent(reward.code)+'?redirect='+encodeURIComponent(redirect);
  }
  if(success){localStorage.setItem(key,String(Date.now()+30*86400000));open();}
  else if(hasError)open();
  else if(Date.now()>until){var popupScheduled=false;function scheduleWelcome(){if(popupScheduled)return;popupScheduled=true;window.setTimeout(function(){if(document.visibilityState==='visible'&&!popup.classList.contains('is-open'))open();},Math.max(8000,Number(popup.dataset.delay||2000)));}window.addEventListener('pointerdown',scheduleWelcome,{once:true,passive:true});window.addEventListener('scroll',function(){if(window.scrollY>window.innerHeight*0.5)scheduleWelcome();},{passive:true});}
});
